/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import {useTranslation} from "react-i18next";
import PageBox from "../../layouts/pageBox";
import {Navigate} from "react-router-dom";

const AdsPolicy = () => {

    return <Navigate to="/" replace />;

    const { t, i18n } = useTranslation();

    const data = {
        title: t('adsPolicy.title'),
        subtitle: ''
    };

    return (
        <PageBox data={data} showAdds={false}>
            <div className='page-body'>
                <div dangerouslySetInnerHTML={{__html: t('adsPolicy.content' ) }} />
            </div>
        </PageBox>
    );
};

export default AdsPolicy;
